import React, { useState } from 'react'
import { Trans } from '@lingui/macro'

import { TopicModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { usePatchDraftMutation } from './operations/patchDraft.codegen'

import './VideoAssessment.less'
import { useTopicForEditQuery } from 'front-end/src/pages/topic-edit-page/TopicEditPage'
import { DrawerItem, DrawerItemHeader } from 'front-end/src/components'

export const SetVideoAssessmentTitle = () => {
  const [patchDraft] = usePatchDraftMutation()
  const { data, refetch: refetchTopic } = useTopicForEditQuery()
  const topic = data?.topic as TopicModelAsEditor

  const { draftVersion } = topic
  const [title, setTitle] = useState(draftVersion?.title || '')

  if (!draftVersion) {
    return null
  }

  const patch = async () => {
    await patchDraft({
      variables: {
        topicId: topic.id,
        input: {
          title
        }
      }
    })
    refetchTopic()
  }

  return (
    <DrawerItem>
      <DrawerItemHeader>
        <Trans>Title</Trans>
      </DrawerItemHeader>

      <textarea
        className="setting-textarea"
        value={title}
        rows={5}
        onChange={(e) => setTitle(e.target.value)}
        onBlur={patch}
      />
    </DrawerItem>
  )
}
